import React, { useCallback, useState, useMemo } from "react";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { SelectBox, TextInput } from "../UIkit";
import { deducationList, HALF_DEDUCTION } from "../../constants/deduction";

const useStyles = makeStyles({
  iconCell: {
    padding: 0,
    height: 48,
    width: 48,
  },
  checkIcon: {
    float: "right",
  },
  inputText: {
    display: "flex",
    gap: "10px",
    padding: "0 10px",
  },
  selectBox: {
    display: "flex",
    width: "100%",
    padding: "0 10px",
    gap: "10px",
    alignItems: "flex-start",
  },
  limit: {
    marginTop: "-5px",
  },
});

const SetCategoriesArea = (props) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0),
    [id, setId] = useState(""),
    [cid, setCid] = useState(""),
    [deducation, setDeducation] = useState(HALF_DEDUCTION),
    [limit, setLimit] = useState(1),
    [name, setName] = useState("");
  const [editingIndex, setEditingIndex] = useState(-1);

  const inputCid = useCallback(
    (event) => {
      setCid(event.target.value);
    },
    [setCid]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );
  const inputDeducation = useCallback((value) => {
    setDeducation(value);
  }, []);
  const inputLimit = useCallback((event) => {
    setLimit(event.target.value);
  }, []);
  const addCategory = (index, cid, name, deducation, limit) => {
    if (cid === "" || name === "" || deducation === "" || limit === "") {
      return false;
    } else {
      if (index === props.categories.length) {
        props.setCategories((prevState) => [
          ...prevState,
          {
            id: "",
            cid: cid,
            name: name,
            deducation: Number(deducation),
            limit: Number(limit),
          },
        ]);
        //props.setCategories(prevState => [...props.categories, {id:"", cid:cid, name:name}])
        setIndex(index + 1);
        setCid("");
        setName("");
        setDeducation(HALF_DEDUCTION);
        setLimit(1);
      } else {
        const newCategories = props.categories;
        newCategories[index] = {
          ...newCategories[index],
          cid: cid,
          name: name,
          deducation: Number(deducation),
          limit: Number(limit),
        };
        props.setCategories(newCategories);
        setIndex(newCategories.length);
        setCid("");
        setName("");
        setDeducation(HALF_DEDUCTION);
        setLimit(1);
      }
      setEditingIndex(-1);
    }
  };

  // const editCategory = (index, cid, name) =>{
  //     setIndex(index);
  //     setCid(cid);
  //     setName(name);
  // }
  const editCategory = (index, cid, name, deducation, limit) => {
    setIndex(index);
    setCid(cid);
    setName(name);
    setDeducation(deducation);
    setLimit(limit);
    setEditingIndex(index); // 編集中の行をセット
  };

  const deleteCategory = (deleteIndex) => {
    const newCategories = props.categories.filter(
      (item, i) => i !== deleteIndex
    );
    props.setCategories(newCategories);
  };
  const memoIndex = useMemo(() => {
    setIndex(props.categories.length);
  }, [props.categories.length]);
  console.log("categories", props.categories);
  return (
    <div aria-label="カテゴリー展開">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          {/* ヘッダー部分はそのまま */}
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>カテゴリー名</TableCell>
              <TableCell className={classes.iconCell} />
              <TableCell className={classes.iconCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.categories.length > 0 &&
              props.categories.map((item, i) => (
                <React.Fragment key={i}>
                  {/* 通常の行 */}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {item.cid}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() =>
                          editCategory(
                            i,
                            item.cid,
                            item.name,
                            item.deducation,
                            item.limit
                          )
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => deleteCategory(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* 編集中の行の場合、入力フィールドをここに表示 */}
                  {editingIndex === i && i !== props.categories.length - 1 && (
                    // <TableRow>
                    //     {/* 入力フィールド */}
                    //     <TableCell colSpan={4}>
                    //         {/* ここにTextInputコンポーネント */}
                    //         {/* ... */}
                    //     </TableCell>
                    // </TableRow>
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div className={classes.inputText}>
                          <TextInput
                            fullWidth={false}
                            label={"ID"}
                            multiline={false}
                            required={true}
                            onChange={inputCid}
                            minRows={1}
                            value={cid}
                            type={"text"}
                          />
                          <TextInput
                            fullWidth={false}
                            label={"カテゴリー名"}
                            multiline={false}
                            required={true}
                            onChange={inputName}
                            minRows={1}
                            value={name}
                            type={"text"}
                          />
                        </div>
                        <div className={classes.selectBox}>
                          <SelectBox
                            label={"控除区分"}
                            options={deducationList}
                            required={true}
                            select={inputDeducation}
                            value={deducation}
                          />
                          <div className={classes.limit}>
                            <TextInput
                              fullWidth={false}
                              label={"上限"}
                              multiline={false}
                              required={true}
                              onChange={inputLimit}
                              minRows={1}
                              value={limit}
                              type={"number"}
                            />
                          </div>
                        </div>
                        <IconButton
                          className={classes.checkIcon}
                          onClick={() =>
                            addCategory(index, cid, name, deducation, limit)
                          }
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        {/* 編集中の行がない場合、入力フィールドを通常通りここに表示 */}
        {(editingIndex === -1 ||
          editingIndex === props.categories.length - 1) && (
          <>
            <div className={classes.inputText}>
              <TextInput
                fullWidth={false}
                label={"ID"}
                multiline={false}
                required={true}
                onChange={inputCid}
                minRows={1}
                value={cid}
                type={"text"}
              />
              <TextInput
                fullWidth={false}
                label={"カテゴリー名"}
                multiline={false}
                required={true}
                onChange={inputName}
                minRows={1}
                value={name}
                type={"text"}
              />
            </div>
            <div className={classes.selectBox}>
              <SelectBox
                label={"控除区分"}
                options={deducationList}
                required={true}
                select={inputDeducation}
                value={deducation}
              />
              <div className={classes.limit}>
                <TextInput
                  fullWidth={false}
                  label={"上限"}
                  multiline={false}
                  required={true}
                  onChange={inputLimit}
                  minRows={1}
                  value={limit}
                  type={"number"}
                />
              </div>
            </div>
            <IconButton
              className={classes.checkIcon}
              onClick={() => addCategory(index, cid, name, deducation, limit)}
            >
              <CheckCircleIcon />
            </IconButton>
          </>
        )}
        {/* <div className={classes.inputText}>
                    <TextInput
                        fullWidth={false} label={"ID"} multiline={false} required={true}
                        onChange={inputCid} minRows={1} value={cid} type={"text"}
                    />
                    <TextInput
                        fullWidth={false} label={"カテゴリー名"} multiline={false} required={true}
                        onChange={inputName} minRows={1} value={name} type={"text"}
                    />
                </div>
                <IconButton className={classes.checkIcon} onClick={() => addCategory(index, cid, name)}>
                    <CheckCircleIcon/>
                </IconButton> */}
      </TableContainer>
      <div className="module-spacer--small" />
    </div>
  );
};

export default SetCategoriesArea;
